import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { BASE_URL } from "../utils/api";
import { useNavigate } from "react-router-dom";

const Productmanagement = () => {

  const navigate = useNavigate();
  const UserId = "66abc123def4567890abcd12";

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [search, setSearch] = useState(""); // 🔹 search input

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOrders, setTotalOrders] = useState(0);
  const [gotoPage, setGotoPage] = useState("");


  const fetchProducts = async (page = 1) => {
    try {
      const res = await fetch(getApiUrl("product-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId, page }),
      });

      const result = await res.json();
      if (result.success) {
        setProducts(result.data);
        setFilteredProducts(result.data); // initially show all
        setCurrentPage(result.pagination.currentPage);
        setTotalPages(result.pagination.totalPages);
        setTotalOrders(result.pagination.totalProducts);
      }
    } catch (error) {
      toast.error("Failed to fetch product list");
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // 🔹 filter products by name
  useEffect(() => {
    if (!search) {
      setFilteredProducts(products);
    } else {
      const term = search.toLowerCase().trim();
      const filtered = products.filter((p) =>
        (p.productName || "").toLowerCase().includes(term)
      );
      setFilteredProducts(filtered);
    }
  }, [search, products]);

  const handleEdit = (product) => {
    navigate("/bsk-secure-admin/new-product", { state: { product } });
  };

  const handleDelete = async (id) => {
    const res = await fetch(getApiUrl("product-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productid: id }),
    });

    const result = await res.json();
    if (result.success) {
      toast.success("Product Deleted Successfully!");
      fetchProducts(currentPage); // keep current page
    }
  };

  const columns = [
    {
      name: "Si No",
      selector: (row, index) => totalOrders - ((currentPage - 1) * 10 + index),
    },
  {
  name: "Product Name",
  cell: (row) => (
    <div 
      style={{ 
        wordBreak: "break-word",
        overflowWrap: "break-word",
        lineHeight: 1.4,
        maxHeight: "80px", 
        overflow: "hidden"
      }} 
      title={row.productName}
    >
      {row.productName}
    </div>
  ),
},



    { name: "Price", selector: (row) => `₹ ${row.price}` },
    { name: "Discount", selector: (row) => `${row.discount}%` },
    {
      name: "Remaining",
      selector: (row) => row.totalProducts,
    },
    {
      name: "Available Sizes",
      cell: (row) => {
        const available = Object.entries(row.sizes || {})
          .filter(([size, qty]) => qty > 0)
          .map(([size, qty]) => `${size} = ${qty}`)
          .join(", ");
        return available || "Out of Stock";
      },
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}${row.mainImage}`}
          alt={row.productName}
          width="60"
          height="60"
          style={{ borderRadius: "8px", objectFit: "cover" }}
        />
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-warning btn-sm me-2"
            onClick={() => handleEdit(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </>
      ),
    },
  ];
  const handleGotoPage = () => {
  const pageNum = Number(gotoPage);

  if (!pageNum || pageNum < 1 || pageNum > totalPages) {
    toast.error(`Please enter a page between 1 and ${totalPages}`);
    return;
  }

  fetchProducts(pageNum);
};


  return (
    <div className="container-fluid mt-4">
      <div>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "4px 10px",
            fontSize: "12px",
            borderRadius: "6px",
            border: "1px solid #ddd",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          ← Back
        </button>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Product Management</h3>
        <div className="d-flex gap-2">
          <input
            type="text"
            className="form-control"
            placeholder="🔍 Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={() => navigate("/bsk-secure-admin/new-product")}
          >
            Add Product
          </button>
        </div>
      </div>
      <div className="d-flex align-items-center gap-2 mb-2">
  <span>Go to page:</span>
  <input
    type="number"
    className="form-control"
    style={{ width: "100px" }}
    value={gotoPage}
    onChange={(e) => setGotoPage(e.target.value)}
    min={1}
    max={totalPages}
  />
  <button className="btn btn-secondary btn-sm" onClick={handleGotoPage}>
    Go
  </button>
</div>


      <ReusableTable
        columns={columns}
        data={filteredProducts} // 🔹 use filteredProducts
        title="Product List"
        currentPage={currentPage}
        totalPages={totalPages}
        totalOrders={totalOrders}
        onChangePage={(page) => fetchProducts(page)}
      />
    </div>
  );
};

export default Productmanagement;
